import { createApiSlice } from 'app/createApiSlice'

export const requestTransactionApiSlice = createApiSlice.injectEndpoints({
  reducerPath: 'requestTrxApi',
  endpoints(builder) {
    return {
      checkDataTrx: builder.query({
        query({ code, amount }) {
          return {
            url: '/api/v1/bussines/public/transaction',
            params: { code, amount },
          }
        },
      }),
      adjustBySeller: builder.mutation({
        query(body) {
          return {
            url: '/api/v1/bussines/transaction/adjustment/adjustbyseller',
            method: 'POST',
            body,
          }
        },
      }),
      releaseBySeller: builder.mutation({
        query(body) {
          return {
            url: '/api/v1/bussines/transaction/adjustment/releasebyseller',
            method: 'POST',
            body,
          }
        },
      }),
    }
  },
})

export const {
  useCheckDataTrxQuery,
  useAdjustBySellerMutation,
  useReleaseBySellerMutation,
} = requestTransactionApiSlice
